import React from "react";
import { PackageDetails, ServiceInfo } from "../../types/serviceDetail";
import { TooltipLink } from "../TooltipLink/TooltipLink";
import HandleModel from "../handleModel/HandleModel";
import { useCart } from "../../hooks/useCart";
import { AnimatedNumber } from "../cardItem/AnimatedNumber";

interface PriceData {
  PriceRecordId: number;
  PriceServiceName: string;
  PriceType: string;
  PriceAmount: number;
  PriceCurrency: string;
  Description: string | null;
  serviceName: string;
  serviceid: number;
  OldPriceAmount: number;
}

interface Props {
  service?: ServiceInfo;
  priceData: PriceData[];
  slugUrl?: string | null;
  isPage?: boolean | false;
  isPackage?: boolean | false;
  type?: string | null;
  selectedService?: PackageDetails | null;
  handleProceedButton?: any;
}

const Service: React.FC<Props> = ({
  service,
  priceData,
  isPage,
  selectedService,
  isPackage,
  type,
  handleProceedButton,
}) => {
  const { updateCartQuantity, getPriceIdByServiceId, countByService } =
    useCart();
  const minPrice =
    priceData.length > 0
      ? Math.min(
          ...priceData.map((price) => price.PriceAmount)
        ).toLocaleString()
      : "N/A";

  return (
    <>
      {service && (
        <div
          className={`${
            isPackage && type == "groupPackage" ? "" : "modal-service-card"
          } py-3`}
        >
          <div className="row justify-content-center">
            <div className="col-md-12 serv-cardwrap">
              <div className="list-card-main shadow-none border-0 d-flex align-items-start align-items-md-center mb-0  bg-3 gap-3 py-2 flex-row-reverse justify-content-between">
                <div>
                  <div className="image-container">
                    {service.imageSrc && (
                      <img
                        loading="lazy"
                        src={service.imageSrc}
                        alt={service.serviceName || "Service Image"}
                        className="img-fluid d-block mx-auto"
                      />
                    )}
                    {(!isPackage || type !== "groupPackage") && (
                      <>
                        {getPriceIdByServiceId(service?.Recordid) ? (
                          <div className="d-flex flex-column align-items-center justify-content-center">
                            <div className="d-flex align-items-center btn-add position-absolute gap-1 gap-md-2">
                              <button
                                className="bt-mi p-0"
                                onClick={() =>
                                  updateCartQuantity(
                                    service.Recordid,
                                    service.Recordid,
                                    "minus"
                                  )
                                }
                              >
                                -
                              </button>
                              <span className="counter-numbers down">
                                {/* {getPriceIdByServiceId(service?.Recordid)} */}
                                <AnimatedNumber
                                  value={countByService(service?.Recordid) || 0}
                                />
                              </span>
                              <button
                                className="bt-plu p-0"
                                onClick={() =>
                                  updateCartQuantity(
                                    service.Recordid,
                                    service.Recordid,
                                    "plus"
                                  )
                                }
                              >
                                +
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div
                            className="btn-add position-absolute"
                            onClick={handleProceedButton}
                          >
                            Add
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
                <div className="col-8">
                  {isPackage && (
                    <span className="cart-cat-badge font-13 ff-semibold text-primary d-block">
                      {type !== "groupPackage"
                        ? "Visa Package"
                        : service?.serviceName}
                    </span>
                  )}
                  <div className="">
                    {isPage ? (
                      <h1
                        className="mb-2 ff-semibold text-black text-left font-20"
                        dangerouslySetInnerHTML={{
                          __html:
                            (!isPackage
                              ? service?.serviceName ?? ""
                              : type !== "groupPackage"
                              ? service?.serviceName
                              : selectedService?.Name) || "",
                        }}
                      />
                    ) : (
                      <p
                        className="mb-2 font-16  ff-bold text-black"
                        dangerouslySetInnerHTML={{
                          __html:
                            (!isPackage
                              ? service?.serviceName ?? ""
                              : type !== "groupPackage"
                              ? service?.serviceName
                              : selectedService?.Name) || "",
                        }}
                      />
                    )}
                  </div>
                  <div className="d-flex align-items-center gap-2 mb-2">
                    {service.noOfApplication && (
                      <div className="d-flex">
                        <div
                          style={{
                            width: "14px",
                            height: "14px",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: "5px",
                          }}
                        >
                          <svg
                            width="14"
                            height="17"
                            viewBox="0 0 14 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.5 1.5V4.61111C8.5 4.81739 8.58194 5.01522 8.72781 5.16108C8.87367 5.30694 9.0715 5.38889 9.27778 5.38889H12.3889"
                              stroke="#6E42E5"
                              stroke-width="1.55556"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M10.8333 15.5H3.05556C2.643 15.5 2.24733 15.3361 1.95561 15.0444C1.66389 14.7527 1.5 14.357 1.5 13.9444V3.05556C1.5 2.643 1.66389 2.24733 1.95561 1.95561C2.24733 1.66389 2.643 1.5 3.05556 1.5H8.5L12.3889 5.38889V13.9444C12.3889 14.357 12.225 14.7527 11.9333 15.0444C11.6416 15.3361 11.2459 15.5 10.8333 15.5Z"
                              stroke="#6E42E5"
                              stroke-width="1.55556"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M4.61133 10.8333L6.16688 12.3889L9.27799 9.27777"
                              stroke="#6E42E5"
                              stroke-width="1.55556"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <span className="font-12 ff-medium">
                          {service.noOfApplication || 0}
                        </span>
                      </div>
                    )}
                    {service.tooltipData && (
                      <TooltipLink
                        title={service.tooltipData}
                        Id={`service-pop-${service.Recordid}`}
                        styleName="none"
                      >
                        <div className="d-flex align-items-center gap-1 bg-beige include-main cursor-pointer">
                          <span className="font-12 ff-medium">Includes</span>
                        </div>
                      </TooltipLink>
                    )}
                  </div>
                  {priceData.length > 0 && (
                    <div className="d-flex align-items-center gap-2 flex-wrap">
                      <p className="d-flex align-items-center gap-1">
                        <span className="in-badge px-0">
                          Start from{" "}
                          <span className="ff-currency ff-medium  font-15">
                            
                          </span>
                          <span className="ff-bold font-13">
                            {priceData[0].PriceCurrency}
                            {!isPackage
                              ? minPrice
                              : selectedService?.totalPrice}
                          </span>
                        </span>
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <HandleModel />
    </>
  );
};

export default Service;
